import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
  ID1sgzzdpfpwkrm as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { get_remittance317c7kdoa7qw as get_remittance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Companion_instance177q6f44m9gy2 as Companion_instance } from '../components/remittanceBreakdownGrid.mjs';
import {
  remittanceSummary7eycmz4clrlq as remittanceSummary,
  remittanceChildTotals1vleuy0834qvm as remittanceChildTotals,
} from './remittanceComponents.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Cents1lsbs5l1tlgw as Cents,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  goBackButton1g9k0xsmfm57i as goBackButton,
  keyValue1ck7xpd7fxylw as keyValue,
} from '../components/view-utilities.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { ID1m87d1hextx54 as ID_0 } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function RemittanceDetailPage$_get_title_$lambda_4m7huw($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDetailPageTitle_pimg0h_k$();
}
function RemittanceDetailPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_singleChildDay_52scz3_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp$ret$1 = eq(get_remittance(it), new (ID())(this$0.id_1));
    return yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1, VOID, VOID, 100000), $completion);
  }), 1);
}
function RemittanceDetailPage$render$slambda_0($days) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $days;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    return yield* tmp.calculate_mx8h7j_k$(tmp$ret$0, $completion);
  }), 1);
}
function RemittanceDetailPage$render$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceStatusLabel_ozb6h1_k$();
}
function RemittanceDetailPage$render$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceIssuedAtLabel_sk6ikx_k$();
}
function RemittanceDetailPage$render$lambda_1($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceAmountLabel_u9neaz_k$();
}
function RemittanceDetailPage$render$lambda$lambda($next) {
  return ($this$swap) => {
    var it = $next;
    remittanceSummary($this$swap, it);
    return Unit_instance;
  };
}
function RemittanceDetailPage$render$lambda$lambda_0($next) {
  return ($this$swap) => {
    var destruct = $next;
    var grid = destruct.component1_7eebsc_k$();
    var forDates = destruct.component2_7eebsb_k$();
    remittanceChildTotals($this$swap, grid, forDates);
    return Unit_instance;
  };
}
function RemittanceDetailPage$render$lambda$lambda$lambda(day) {
  return new (Cents())(day.totalContributions_1);
}
function RemittanceDetailPage$render$lambda$lambda_1($next) {
  return ($this$swap) => {
    $next.render_b3nvws_k$($this$swap, RemittanceDetailPage$render$lambda$lambda$lambda);
    return Unit_instance;
  };
}
function RemittanceDetailPage$render$lambda_2($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
var RemittanceDetailPageClass;
function RemittanceDetailPage() {
  if (RemittanceDetailPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, RemittanceDetailPage$_get_title_$lambda_4m7huw);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.fullWidthPage' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        var remittance = remember(VOID, VOID, VOID, VOID, ($this$remember) => ensureNotNull($this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviderRemittances_dyezti_k$().get_6ueaa7_k$(new (ID())(this.id_1)))));
        var days = rememberSuspending(VOID, VOID, VOID, RemittanceDetailPage$render$slambda(this));
        var grid = rememberSuspending(VOID, VOID, VOID, RemittanceDetailPage$render$slambda_0(days));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_1 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_2 = weight(this_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_0())($this$invoke.invoke_r7m7el_k$(remittance).provider_1)));
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element.willAddChild_hz2iwc_k$(element_2);
        element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(remittance).forDates_1.toString());
        element_2.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_3 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        var tmp_5 = RemittanceDetailPage$render$lambda;
        keyValue(element_3, tmp_5, ($this$keyValue) => {
          var tmp0_safe_receiver = $this$keyValue.invoke_r7m7el_k$(remittance).status_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        var tmp_6 = RemittanceDetailPage$render$lambda_0;
        keyValue(element_3, tmp_6, ($this$keyValue) => {
          var tmp0_safe_receiver = $this$keyValue.invoke_r7m7el_k$(remittance).at_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        var tmp_7 = RemittanceDetailPage$render$lambda_1;
        keyValue(element_3, tmp_7, ($this$keyValue) => Cents__toString_impl_ko5hxm($this$keyValue.invoke_r7m7el_k$(remittance).amount_1));
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_4 = element_4;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_4, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(days);
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_4.swap_26x94b_k$(tmp_0, RemittanceDetailPage$render$lambda$lambda(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element.willAddChild_hz2iwc_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_5 = element_5;
        var queue_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping_0 = {_v: false};
        reactive(this_5, 8, ($this$reactive) => {
          var c = to($this$reactive.invoke_r7m7el_k$(grid), $this$reactive.invoke_r7m7el_k$(remittance).forDates_1);
          queue_0.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping_0._v) {
            return Unit_instance;
          }
          alreadySwapping_0._v = true;
          $l$loop_0: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue_0.isEmpty_y1axqb_k$()) {
              break $l$loop_0;
            }
            var next = queue_0.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_5.swap_26x94b_k$(tmp_0, RemittanceDetailPage$render$lambda$lambda_0(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping_0._v = false;
          return Unit_instance;
        });
        element_5.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_6 = element_6;
        var queue_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping_1 = {_v: false};
        reactive(this_6, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(grid);
          queue_1.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping_1._v) {
            return Unit_instance;
          }
          alreadySwapping_1._v = true;
          $l$loop_1: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue_1.isEmpty_y1axqb_k$()) {
              break $l$loop_1;
            }
            var next = queue_1.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_6.swap_26x94b_k$(tmp_0, RemittanceDetailPage$render$lambda$lambda_1(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping_1._v = false;
          return Unit_instance;
        });
        element_6.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_7 = shownWhen(element, VOID, VOID, RemittanceDetailPage$render$lambda_2);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (Space())(this_7.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_7);
        this_7.willAddChild_hz2iwc_k$(element_7);
        element_7.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_7);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'RemittanceDetailPage', VOID, VOID, [Page()]);
    RemittanceDetailPageClass = $;
  }
  return RemittanceDetailPageClass;
}
//region block: exports
export {
  RemittanceDetailPage as RemittanceDetailPage384df89l74tfl,
};
//endregion

//# sourceMappingURL=RemittanceDetailPage.mjs.map
